import subscriptionImageEn from '@/assets/images/default/subscription-ad-en.png';
import subscriptionImageKo from '@/assets/images/default/subscription-ad-ko.png';
import { Device, Sound, Store } from '@/classes';
import { keyCodes } from '@/constants/keyCode';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { useRouter } from '@/hooks/useRouter';
import { Resource } from '@/types';
import { stringify } from 'qs';
import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

interface ButtonProps {
  tabIndex: number;
  focusKey: string;
  title: string;
  onFocused: ({ x, top }: { x: number; top: number }) => void;
}

export function SubscriptionADCard({ tabIndex, focusKey, onFocused, title }: ButtonProps) {
  const router = useRouter();
  const [searchParams] = useSearchParams();
  const { ref, focused, focusSelf } = useExtendFocusable({ focusKey, onFocus: onFocused });

  const subscriptionAdVideo = useMemo(() => {
    const resources: Resource = Store.get('resources');
    return resources.subscriptionAdVideo;
  }, []);

  const handleClick = useCallback(() => {
    Sound.press();
    router.push(`/videos?${stringify({ url: subscriptionAdVideo })}`, { focusKey });
  }, [router, focusKey, subscriptionAdVideo]);

  useEffect(() => {
    const targetFocusKey = searchParams.get('f');
    if (focusKey === targetFocusKey) {
      focusSelf();
    }
  }, [focusKey, focusSelf, searchParams]);

  useFocusElement({ ref, focused, onClick: handleClick, keyCode: keyCodes.ENTER });

  return (
    <div
      tabIndex={tabIndex}
      ref={ref}
      className={`relative w-[484px] h-[272px] overflow-hidden rounded-[15px] ease-in-out duration-300 outline-disable outline-primary-12`}
      style={{
        minWidth: '24rem',
        margin: '0 0.5rem',
      }}
      onClick={handleClick}
      onContextMenu={handleClick}
    >
      <img
        src={Device.language === 'ko' ? subscriptionImageKo : subscriptionImageEn}
        className="absolute w-full h-full object-cover"
        loading="lazy"
      />
      <div
        className="absolute w-full z-20 bg-[rgba(0,0,0,0.5)] text-white"
        style={{
          left: 0,
          bottom: 0,
          height: `${52}px`,
          padding: '5px 15px',
        }}
      >
        <span
          className={`tracking-wide whitespace-nowrap`}
          style={{
            fontSize: `28px`,
          }}
        >
          {title}
        </span>
      </div>
    </div>
  );
}
